import http from '@/js/helpers/http';

const url = '/local/services/api/geoloc/get_cities.php';

async function get(data = {}) {
  return new Promise((resolve, reject) => {
    http.get(url, {
      fias: data.location,
      city: data.query,
    })
      .then(({ cities }) => {
        const citiesList = cities || [];
        resolve(citiesList.map(city => ({
          location: city.code,
          name: city.name,
        })));
      })
      .catch((error) => {
        reject(error.message);
      });
  });
}

export default { get };
